module.exports = __webpack_public_path__ + "img/BackGeo.b77f7a29.svg";